const intentAttributes = {
  BLACK_LIST: {
    DEFAULT: [
      'allowEnrollment',
      'allowRXO',
      'allowEXO',
      'id',
      'intentId',
      'paymentInstrument',
      'responseStatus',
      'shippingAddress',
      'settings'
    ],

    UPDATE_INTENT: [
      'buttonAction',
      'cardArt',
      'channel',
      'currencyCode',
      'customData',
      'customerSupportUrl',
      'description',
      'discount',
      'displayName',
      'encryptionKey',
      'eventSource',
      'externalClientId',
      'giftWrap',
      'locale',
      'logoUrl',
      'merchantId',
      'merchantRequestId',
      'merchantConfig',
      'misc',
      'orderId',
      'promoCode',
      'referenceCallID',
      'reviewMessage',
      'shippingHandling',
      'sourceId',
      'subtotal',
      'tax',
      'total',
      'websiteUrl',
      'modifiedAmount'
    ]
  },

  // attrbiutes that should not be part of set intent call
  IGNORED_ATTRIBUTES: [
    'allowEXO',
    'allowGXO',
    'allowRXO',
    'bannerURL',
    'clientId',
    'defaultProfile',
    'logo',
    'bannerURL',
    'enableUserDataPrefill'
  ],

  // allowed attributes in merchant config.
  MERCHANT_CONFIG_WHITE_LIST: [
    'billingConstraints',
    'buttonAnimationEnabled',
    'allowEnrollment',
    'buttonPosition',
    'datalevel',
    'displayName',
    'encryptionKey',
    'externalProfileId',
    'logoUrl',
    'paymentConstraints',
    'shippingConstraints',
    'tokenizationSetup',
    'threeDSSetup',
    'widgetStyle',
    'websiteUrl',
    'customerSupportUrl',
    'returningUserWelcomeMessage',
    'newUserWelcomeMessage',
    'newUserWelcomeMessageDescription',
    'backgroundImageId',
    'currencyFormat',
    'srcDpaId'
  ],

  // derived from API documentation (https://wiki/pages/viewpage.action?pageId=44443920#SetIntent%28WalletServices%29-Requestschemaz34)
  SCHEMA_SURFACE: [
    'apikey',
    'buttonAction',
    'channel',
    'consumerNationalIdentifierRequested',
    'countryCode',
    'currencyCode',
    'currencyFormat',
    'customData',
    'description',
    'discount',
    'enableThreeDS',
    'encryptionKey',
    'eventSource',
    'externalClientId',
    'externalProfileId',
    'giftWrap',
    'locale',
    'merchantConfig',
    'merchantRequestId',
    'misc',
    'nvPair',
    'orderId',
    'paymentRequest',
    'promoCode',
    'referenceCallID',
    'reviewMessage',
    'settings',
    'shippingConstraints',
    'shippingHandling',
    'signature',
    'sourceId',
    'subtotal',
    'tax',
    'total'
  ]
};

export default intentAttributes;
